<div
  class="group w-full min-w-0 cursor-pointer select-none overflow-hidden rounded-xl shadow-sm"
  [ngClass]="{
    'p-[12px]': compact,
    'p-3': !compact,
    'inset-ring-3! inset-ring-amber-600!': viewers.length,
    'inset-ring-2! inset-ring-blue-600!': selected
  }"
  [style.backgroundColor]="card.color.background"
  [style.color]="card.color.text"
  [cdkContextMenuTriggerFor]="cardMenu"
  [cdkContextMenuDisabled]="isTouchContextMenuDisabled"
  (click)="onCardActivate()"
  (contextmenu)="onContextMenu($event)"
>
  <div class="flex items-start justify-between gap-2">
    <div class="min-w-0 flex-1 truncate text-base font-bold" [title]="card.name">{{ displayCardName() }}</div>
    <div class="flex shrink-0 items-center gap-2">
      @if (viewers.length) {
        <app-board-v3-presence-avatars
          [viewers]="viewers"
          [avatarSize]="'24px'"
          [stackClass]="'-space-x-1'"
          [avatarWrapperClass]="'ring-2 ring-white'"
          [extraClass]="'h-6 min-w-6 bg-white px-1 text-[10px] text-gray-600'"
        />
      }
      @if (has('price')) {
        <div
          class="shrink-0 whitespace-nowrap rounded-full border border-emerald-400 bg-emerald-100 px-2.5 py-1 text-xs font-semibold text-emerald-800"
          [title]="systemPriceValue"
        >
          {{ displaySystemPriceValue() }}
        </div>
      }
      @if (selectionMode) {
        <span class="flex h-7 w-7 shrink-0 items-center justify-center" (click)="$event.stopPropagation()">
          <app-checkbox
            [checked]="selected"
            [disableRipple]="true"
            (change)="onSelectionChange()"
          />
        </span>
      } @else {
        <button
          type="button"
          class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md! text-gray-400 hover:bg-gray-50 hover:text-gray-700"
          [attr.aria-label]="'board_v3_card_actions' | translate"
          [cdkMenuTriggerFor]="cardMenu"
          (click)="$event.stopPropagation()"
        >
          <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">more_vert</app-icon>
        </button>
      }
    </div>
  </div>

  <ng-template #cardMenu>
    <div cdkMenu class="min-w-44 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
      <button
        type="button"
        cdkMenuItem
        class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
        (click)="$event.stopPropagation(); onSelectionChange()"
      >
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-gray-500">
          {{ selected ? 'check_box' : 'check_box_outline_blank' }}
        </app-icon>
        <span>{{ (selected ? 'board_v3_deselect_card' : 'board_v3_select_card') | translate }}</span>
      </button>
      <div class="my-1 h-px bg-gray-100"></div>
      @if (canMove) {
        <button
          type="button"
          cdkMenuItem
          class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
          (click)="onOpenMoveSidebar($event)"
        >
          <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-gray-500">drive_file_move</app-icon>
          <span>{{ 'board_v3_move_card' | translate }}</span>
        </button>
        <div class="my-1 h-px bg-gray-100"></div>
      }
      <button
        type="button"
        cdkMenuItem
        class="flex w-full items-center gap-2 rounded-md! px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
        (click)="$event.stopPropagation(); cardDelete.emit(card)"
      >
        <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-red-500">delete_outline</app-icon>
        <span>{{ 'board_v3_delete_card' | translate }}</span>
      </button>
    </div>
  </ng-template>

  @if (has('assigned_id')) {
    <div
      [class]="compact
        ? 'mt-1.5 flex min-w-0 items-center justify-between gap-[12px] text-sm'
        : 'mt-1.5 flex min-w-0 items-center justify-between gap-3 text-sm'"
    >
      <span class="shrink-0 text-gray-400">{{ 'custom_filters.assigned_id' | translate }}</span>
      <span class="flex min-w-0 items-center gap-2 font-medium">
        <app-avatar
          [url]="getAvatarUrl(card.assigned_id_user)"
          [title]="getAvatarTitle(card.assigned_id_user)"
          size="22px"
          [isPhotoGallery]="false"
        />
        <span class="min-w-0 truncate" [title]="getAvatarTitle(card.assigned_id_user)">{{ displayManagerName(card.assigned_id_user) }}</span>
      </span>
    </div>
  }

  @if (has('clients') && (card.contacts?.length || card.company)) {
    <div
      [class]="compact
        ? 'mt-1.5 flex min-w-0 items-start justify-between gap-[12px] text-sm'
        : 'mt-1.5 flex min-w-0 items-start justify-between gap-3 text-sm'"
    >
      <span class="shrink-0 text-gray-400">{{ 'board_v3_quick_create_clients' | translate }}</span>
      <div class="flex min-w-0 flex-1 flex-col items-end gap-1">
        @for (contact of card.contacts ?? []; track contact.id) {
          <span class="flex max-w-full min-w-0 items-center gap-1.5">
            <app-avatar [title]="getContactName(contact)" size="18px" [isPhotoGallery]="false" />
            <button
              type="button"
              class="min-w-0 truncate text-xs font-medium text-gray-800"
              [ngClass]="compact || selectionMode ? 'cursor-default' : 'hover:text-orange-600 hover:underline'"
              [title]="getContactName(contact)"
              (click)="onContactClick($event, contact)"
            >
              {{ getContactName(contact) }}
            </button>
          </span>
        }
        @if (card.company; as company) {
          <span class="flex max-w-full min-w-0 items-center gap-1.5">
            <span class="grid h-[18px] w-[18px] shrink-0 place-items-center rounded-full bg-gray-100 text-gray-500">
              <app-icon class="!h-3 !w-3 !text-[12px] !leading-none">apartment</app-icon>
            </span>
            <button
              type="button"
              class="min-w-0 truncate text-xs font-medium text-gray-800"
              [ngClass]="compact || selectionMode ? 'cursor-default' : 'hover:text-orange-600 hover:underline'"
              [title]="getCompanyName(company)"
              (click)="onCompanyClick($event, company)"
            >
              {{ getCompanyName(company) }}
            </button>
          </span>
        }
      </div>
    </div>
  }

  @if (has('phones') && card.phones?.length) {
    <div
      [class]="compact
        ? 'mt-1.5 flex min-w-0 items-start justify-between gap-[12px] text-sm'
        : 'mt-1.5 flex min-w-0 items-start justify-between gap-3 text-sm'"
    >
      <span class="shrink-0 text-gray-400">{{ 'phone' | translate }}</span>
      <div class="flex min-w-0 flex-1 flex-col items-end gap-0.5">
        @for (p of card.phones; track p.id) {
          <span class="max-w-full truncate text-xs text-gray-800" [title]="phoneValue(p)">{{ displayPhone(phoneValue(p)) }}</span>
        }
      </div>
    </div>
  }

  @if (has('emails') && card.emails?.length) {
    <div
      [class]="compact
        ? 'mt-1.5 flex min-w-0 items-start justify-between gap-[12px] text-sm'
        : 'mt-1.5 flex min-w-0 items-start justify-between gap-3 text-sm'"
    >
      <span class="shrink-0 text-gray-400">{{ 'email' | translate }}</span>
      <div class="flex min-w-0 flex-1 flex-col items-end gap-0.5">
        @for (e of card.emails; track e.id) {
          <span class="max-w-full truncate text-xs text-gray-800" [title]="e.email">{{ displayEmail(e.email) }}</span>
        }
      </div>
    </div>
  }

  @if (has('addresses') && card.addresses?.length) {
    <div
      [class]="compact
        ? 'mt-1.5 flex min-w-0 items-start justify-between gap-[12px] text-sm'
        : 'mt-1.5 flex min-w-0 items-start justify-between gap-3 text-sm'"
    >
      <span class="shrink-0 text-gray-400">{{ 'address' | translate }}</span>
      <div class="flex min-w-0 flex-1 flex-col items-end gap-0.5">
        @for (a of card.addresses; track $index) {
          <span class="max-w-full truncate text-xs text-gray-800" [title]="addressValue(a)">{{ displayAddress(a) }}</span>
        }
      </div>
    </div>
  }

  @if (has('description') && card.description) {
    <div class="mt-2 truncate text-sm opacity-80" [title]="card.description">{{ displayDescription() }}</div>
  }

  @for (field of unknownFields; track fieldKey(field)) {
    <div
      [class]="compact
        ? 'mt-1.5 flex min-w-0 items-baseline justify-between gap-[12px] text-sm'
        : 'mt-1.5 flex min-w-0 items-baseline justify-between gap-3 text-sm'"
    >
      <span class="shrink-0 text-gray-400" [title]="field.name ?? fieldKey(field)">{{ displayFieldName(field) }}</span>
      @if (isCheckboxField(field)) {
        @if (getCustomFieldValue(fieldKey(field))) {
          <app-icon class="icon-xm shrink-0 !leading-none text-emerald-500">check_circle</app-icon>
        } @else {
          <app-icon class="icon-xm shrink-0 !leading-none text-gray-300">radio_button_unchecked</app-icon>
        }
      } @else if (isLinkField(field) && getCustomFieldValue(fieldKey(field))) {
        <a
          [href]="asString(getCustomFieldValue(fieldKey(field)))"
          target="_blank"
          rel="noopener noreferrer"
          class="min-w-0 flex-1 truncate text-right font-medium text-blue-500 underline"
          [title]="customFieldTitle(field)"
          (click)="$event.stopPropagation()"
        >{{ displayCustomFieldValue(field) }}</a>
      } @else if (isEmailField(field) && getCustomFieldValue(fieldKey(field))) {
        <a
          [href]="'mailto:' + asString(getCustomFieldValue(fieldKey(field)))"
          class="min-w-0 flex-1 truncate text-right font-medium text-blue-500 underline"
          [title]="customFieldTitle(field)"
          (click)="$event.stopPropagation()"
        >{{ displayCustomFieldValue(field) }}</a>
      } @else if (isPhoneField(field) && getCustomFieldValue(fieldKey(field))) {
        <a
          [href]="getPhoneLink(getCustomFieldValue(fieldKey(field)))"
          class="min-w-0 flex-1 truncate text-right font-medium text-blue-500 underline"
          [title]="customFieldTitle(field)"
          (click)="$event.stopPropagation()"
        >{{ displayCustomFieldValue(field) }}</a>
      } @else {
        <span class="min-w-0 flex-1 truncate text-right font-medium" [title]="customFieldTitle(field)">{{ displayCustomFieldValue(field) }}</span>
      }
    </div>
  }

  @if (has('updated_at') || has('actions') || has('updated_by')) {
    <div [class]="compact ? 'my-[12px] border-t border-gray-100' : 'my-3 border-t border-gray-100'"></div>

    <div class="grid grid-cols-[1fr_auto_1fr] items-center">
      <span class="text-xs text-gray-400">
        @if (has('updated_at')) {
          {{ (card.updated_at || card.created_at) | date: 'dd MMM' }}
        }
      </span>

      <div class="flex items-center justify-center gap-2">
        @if (has('actions')) {
          <ng-container [ngTemplateOutlet]="actionBtn" [ngTemplateOutletContext]="{ icon: 'phone', isDisabled: !card.phones?.length, menuRef: phoneMenu }"></ng-container>
          <ng-container [ngTemplateOutlet]="actionBtn" [ngTemplateOutletContext]="{ icon: 'mail_outline', isDisabled: !card.emails?.length, menuRef: emailMenu }"></ng-container>
          <ng-container
            [ngTemplateOutlet]="actionBtn"
            [ngTemplateOutletContext]="{
              icon: 'chat_bubble_outline',
              isDisabled: !hasChats,
              menuRef: chatMenu,
              unreadCount: unreadChatsCount,
              isMarkedUnread: hasMarkedUnreadChat
            }"
          ></ng-container>
        }
      </div>

      <ng-template #phoneMenu>
        <div cdkMenu class="min-w-40 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
          @if (card.phones?.length) {
            @for (p of card.phones; track p.id) {
              <a
                cdkMenuItem
                [href]="'tel:' + phoneValue(p)"
                (click)="$event.stopPropagation()"
                class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 !no-underline !text-gray-700 hover:bg-gray-50"
              >
                <app-icon class="!text-[16px] !h-[16px] !w-[16px] !leading-none text-gray-400">phone</app-icon>
                {{ phoneValue(p) }}
              </a>
            }
          } @else {
            <div class="px-3 py-2 text-sm text-gray-400">—</div>
          }
        </div>
      </ng-template>

      <ng-template #emailMenu>
        <div cdkMenu class="min-w-48 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
          @if (card.emails?.length) {
            @for (e of card.emails; track e.id) {
              <a
                cdkMenuItem
                [href]="'mailto:' + e.email"
                (click)="$event.stopPropagation()"
                class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-sm text-gray-700 !no-underline !text-gray-700 hover:bg-gray-50"
              >
                <app-icon class="!text-[16px] !h-[16px] !w-[16px] !leading-none text-gray-400">mail_outline</app-icon>
                {{ e.email }}
              </a>
            }
          } @else {
            <div class="px-3 py-2 text-sm text-gray-400">—</div>
          }
        </div>
      </ng-template>

      <ng-template #chatMenu>
        <div cdkMenu class="min-w-56 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
          @if (hasChats) {
            @for (chat of chats; track chat.id) {
              <button
                type="button"
                cdkMenuItem
                (click)="$event.stopPropagation(); chatClick.emit(chat)"
                class="flex w-full min-w-0 items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
              >
                <app-icon class="mr-1 !h-4 !w-4 !min-w-4 !text-[16px] !leading-4 text-gray-400">chat_bubble_outline</app-icon>
                <span class="flex min-w-0 flex-1 flex-col">
                  <span class="truncate font-medium">{{ getChatTitle(chat) }}</span>
                  <span class="flex min-w-0 items-center gap-1 text-xs text-gray-400">
                    @if (getChatChannelIcon(chat); as channelIcon) {
                      <img
                        [src]="channelIcon"
                        [alt]="getChatChannelName(chat)"
                        class="h-4 w-4 shrink-0 rounded-full object-contain"
                      />
                    }
                    <span class="min-w-0 flex-1 truncate">{{ getChatChannelName(chat) }}</span>
                  </span>
                </span>
                @if (getChatUnreadCount(chat)) {
                  <span class="flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-red-500 px-1.5 text-[10px] font-bold leading-none text-white">
                    {{ formatUnreadCount(getChatUnreadCount(chat)) }}
                  </span>
                } @else if (chat.is_mark_unread) {
                  <span class="h-2.5 w-2.5 shrink-0 rounded-full bg-red-500"></span>
                }
              </button>
            }
          } @else {
            <div class="px-3 py-2 text-sm text-gray-400">—</div>
          }
        </div>
      </ng-template>

      <div class="flex justify-end">
        @if (has('updated_by') && updatedUser) {
          <app-avatar
            [url]="getAvatarUrl(updatedUser)"
            [title]="getAvatarTitle(updatedUser)"
            size="26px"
            [isPhotoGallery]="false"
          />
        }
      </div>
    </div>
  }
</div>

<ng-template #actionBtn let-icon="icon" let-isDisabled="isDisabled" let-menuRef="menuRef" let-unreadCount="unreadCount" let-isMarkedUnread="isMarkedUnread">
  <span class="relative inline-flex h-7 w-7 shrink-0">
    <button
      type="button"
      class="inline-flex h-7 w-7 shrink-0 items-center justify-center !rounded-md border !border-gray-400 bg-white p-0 leading-none text-gray-900 hover:bg-gray-50 disabled:cursor-not-allowed disabled:!border-gray-300 disabled:text-gray-300"
      [cdkMenuTriggerFor]="menuRef"
      [disabled]="isDisabled"
      (click)="$event.stopPropagation()"
    >
      <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">{{ icon }}</app-icon>
    </button>
    @if (!isDisabled && unreadCount) {
      <span class="pointer-events-none absolute -right-2 -top-2 z-10 flex h-5 min-w-5 items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white ring-2 ring-white">
        {{ formatUnreadCount(unreadCount) }}
      </span>
    } @else if (!isDisabled && isMarkedUnread) {
      <span class="pointer-events-none absolute -right-1 -top-1 z-10 h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-white"></span>
    }
  </span>
</ng-template>
